import { DocumentSectionSpec, SectionOptionSchema } from '@/entities/templates';

type UpdateOptionArgs = {
  sections: DocumentSectionSpec[];
  sectionIndex: number;
  optionIndex: number;
  update: (option: SectionOptionSchema) => SectionOptionSchema;
};

export const updateOption = ({
  sections,
  sectionIndex,
  optionIndex,
  update,
}: UpdateOptionArgs): DocumentSectionSpec[] =>
  sections.map((section, index) =>
    index === sectionIndex
      ? {
          ...section,
          options: (section.options ?? []).map((option, currentIndex) =>
            currentIndex === optionIndex ? update(option) : option,
          ),
        }
      : section,
  );
